export default "__VITE_ASSET__COU28rBW__"